import React from "react";
import { GraduationCap, Users, Sparkles, ArrowRight } from "lucide-react";
import { CALENDLY_URL } from "@/lib/siteData";

export default function Mentoring() {
  return (
    <section id="mentoring" data-testid="mentoring-section" className="py-20 md:py-24 bg-md-bg relative overflow-hidden">
      <div className="absolute -top-32 -right-20 w-[400px] h-[400px] bg-md-accent/10 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="bg-white border border-md-border rounded-3xl p-8 md:p-12 grid lg:grid-cols-12 gap-8 lg:gap-12 items-center shadow-sm">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-md-accent/10 text-md-accent text-[11px] uppercase tracking-[0.2em] font-bold mb-5">
              <GraduationCap className="w-3.5 h-3.5" />
              Pour les futurs CGP
            </div>
            <h2 className="font-serif text-3xl md:text-4xl text-md-primary font-medium leading-tight mb-4">
              Accompagnement & formation <span className="italic">de nouveaux conseillers</span>
            </h2>
            <p className="text-md-muted leading-relaxed mb-6 text-[15px]">
              Vous souhaitez vous lancer comme <strong className="text-md-primary">Conseiller en Gestion de Patrimoine</strong> ?
              Je vous transmets mon expérience, ma méthode et mon réseau pour démarrer sereinement,
              construire votre clientèle et — à votre tour — développer votre équipe.
            </p>

            <ul className="space-y-2.5 mb-7">
              {[
                "Formation aux produits & cadre réglementaire (Orias, AMF, ACPR)",
                "Méthodologie commerciale et fidélisation clients",
                "Accompagnement au lancement & développement d'équipe",
              ].map((t) => (
                <li key={t} className="flex items-start gap-3 text-sm text-md-text">
                  <Sparkles className="w-4 h-4 text-md-secondary mt-0.5 flex-shrink-0" />
                  <span>{t}</span>
                </li>
              ))}
            </ul>

            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="mentoring-cta"
              className="inline-flex items-center gap-2 bg-md-accent hover:bg-md-primary text-white px-6 py-3 rounded-full text-sm font-semibold transition-all hover:-translate-y-0.5"
            >
              Échanger sur votre projet
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>

          <div className="lg:col-span-5">
            <div className="relative aspect-[5/4] rounded-2xl overflow-hidden bg-md-primary">
              <img
                src="https://images.pexels.com/photos/3184464/pexels-photo-3184464.jpeg"
                alt="Accompagnement de nouveaux CGP"
                className="w-full h-full object-cover opacity-90"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-md-primary/80 via-md-primary/20 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 text-white">
                <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-md-secondary font-bold mb-1">
                  <Users className="w-3.5 h-3.5" />
                  Transmission & équipe
                </div>
                <div className="font-serif text-xl leading-tight">Bâtissez votre carrière, je vous guide.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
